
import React from 'react';
import { motion } from 'framer-motion';

const PartnerResults = () => {
  const stats = [
    {
      metric: "300%",
      label: "increase in cosmetic interest after adding JUV"
    },
    {
      metric: "+$24,000",
      label: "monthly revenue added in a 3-op office"
    },
    {
      metric: "5x",
      label: "patient retention with \"Smile + Skin\" memberships"
    }
  ];

  return (
    <section className="py-32 bg-juv-deep-chestnut text-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-light mb-8">
            Real Results from Our Pilot Practices
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="text-center"
            >
              <div className="text-6xl md:text-7xl font-bold text-juv-rose-clay mb-4">
                {stat.metric}
              </div>
              <p className="text-xl text-white/90 leading-relaxed">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="text-center mt-16"
        >
          <p className="text-lg text-white/80 italic">
            Real testimonials and clinical photos available upon request.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerResults;
